import React, { useRef } from 'react';
import ProjectsIntro from './ProjectsIntro';
import WP1 from './WP1';
import WP2 from './WP2';
import WP3 from './WP3';
import WP4 from './WP4';
import WP5 from './WP5';
import '../../styles/projects/projects.css';
import projectIMG from '../../assets/img/work-packages.jpg';

const Project = () => {
	const wpRefs = {
		WP1: useRef(null),
		WP2: useRef(null),
		WP3: useRef(null),
		WP4: useRef(null),
		WP5: useRef(null),
	};

	const handleWpButtonClick = (wpId) => {
		if (wpRefs[wpId] && wpRefs[wpId].current) {
			wpRefs[wpId].current.expandSection();
		}
	};

	return (
		<div className='project-page'>
			<img
				src={projectIMG}
				alt="Work packages banner"
				className="projects-page-banner"
			/>
			<ProjectsIntro onWpButtonClick={handleWpButtonClick} />
			<WP1 ref={wpRefs.WP1} />
			<WP2 ref={wpRefs.WP2} />
			<WP3 ref={wpRefs.WP3} />
			<WP4 ref={wpRefs.WP4} />
			<WP5 ref={wpRefs.WP5} />
		</div>
	);
};

export default Project;
